import * as R from 'ramda';

function isActiveMedication(category) {
    return R.anyPass([R.pathSatisfies(R.isNil, ['status', 'end']), R.pathSatisfies(R.isNil, ['status', 'endReason'])])(
        category
    );
}

export default isActiveMedication;
